import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Loader2 } from 'lucide-react';
import { getGeneralInvPayAccess } from '../../api/AccountsAPI/generalInvoicePaymentAPI';
import GeneralInvoicePayment from './GeneralInvoicePayment';
import GeneralInvoiceCashPayment from './GeneralInvoiceCashPayment';

// Legacy /Accounts/GeneralInvoicePayment is a single menu entry for both cash and bank.
// AccountsController.GeneralInvoicePayment picks the form from GetGeneralInvPayAccess:
// CashAccess -> Cash (checked first), else BankAccess -> Bank, else "Please Assign Workflows for Payments".
const GeneralInvoicePaymentEntry = ({ menuData }) => {
    const { userData } = useSelector((s) => s.auth);
    const roleId = userData?.roleId || userData?.RID || 0;
    const userId = userData?.userId || userData?.UID || userData?.employeeId || '';

    const [mode, setMode] = useState(null); // 'Cash' | 'Bank' | 'None'

    useEffect(() => {
        if (!roleId || !userId) return;
        let cancelled = false;
        getGeneralInvPayAccess(roleId, userId)
            .then((res) => {
                const access = res?.Data || res?.data || res || {};
                const cash = access.CashAccess ?? access.cashAccess;
                const bank = access.BankAccess ?? access.bankAccess;
                if (!cancelled) setMode(cash ? 'Cash' : bank ? 'Bank' : 'None');
            })
            .catch(() => { if (!cancelled) setMode('None'); });
        return () => { cancelled = true; };
    }, [roleId, userId]);

    if (mode === null) {
        return (
            <div className="flex items-center justify-center py-20 text-gray-500 dark:text-gray-400">
                <Loader2 className="w-5 h-5 mr-2 animate-spin" /> Loading payment access...
            </div>
        );
    }
    if (mode === 'Cash') return <GeneralInvoiceCashPayment menuData={menuData} />;
    if (mode === 'Bank') return <GeneralInvoicePayment menuData={menuData} />;
    return (
        <div className="py-20 text-center text-gray-500 dark:text-gray-400">
            Please Assign Workflows for Payments
        </div>
    );
};

export default GeneralInvoicePaymentEntry;
